import axios from 'axios';
import { ORCHESTRATOR_GATEWAY_URL } from '.';
axios.defaults.baseURL = ORCHESTRATOR_GATEWAY_URL;
